import { connect } from "react-redux";
import { getThongBao, updateThongBao, setShowThongBao } from "actions/ThongBao";
import ThongBaoCapNhat from "components/CommonComponent/ThongBaoCapNhat";

const mapStateToProps = (state) => ({
  thongbao: state.thongbao,
});

const mapDispatchToProps = (dispatch) => ({
  getThongBao: (dataSearch) => dispatch(getThongBao(dataSearch)),
  updateThongBao: (dataSearch) => dispatch(updateThongBao(dataSearch)),
  setShowThongBao: () => dispatch(setShowThongBao()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThongBaoCapNhat);
